var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _mask, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNpbsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 40,
    viewBox: "0 0 118 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.252 0L0 9.68V30.281H8.6V39.773H14.611V30.281H33.751V15.238L21.231 9.326L8.6 15.256V24.111H6.067V13.623L21.244 6.555L36.276 13.591V30.258H42.293V9.716L21.256 0H21.252ZM14.611 19.243L21.253 16.105L27.74 19.266V24.111H14.611V19.243Z",
    fill: "#093635"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0746 9.6897H50.2616V15.4187C50.1526 15.2467 46.7146 9.6897 46.7146 9.6897H44.7676V18.4187H46.6246V12.7027C46.7316 12.8767 50.1596 18.4187 50.1596 18.4187H52.1176V9.6897H52.0746Z",
    fill: "#093635"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1684 9.6897H53.6934V18.4187H60.3084V16.7367H55.6704V14.7037H59.8384V13.1397H55.6704V11.3747H60.2114V9.6897H60.1684Z",
    fill: "#093635"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.1537 9.6897H70.2647C70.2647 9.6897 68.9327 15.3197 68.8777 15.5557C68.8187 15.3207 67.4297 9.6897 67.4297 9.6897H65.5917C65.5917 9.6897 64.1797 15.2507 64.1217 15.4847C64.0657 15.2487 62.7797 9.6897 62.7797 9.6897H60.7997L63.0987 18.4187H65.0807C65.0807 18.4187 66.4357 12.8557 66.4927 12.6247C66.5497 12.8557 67.9277 18.4187 67.9277 18.4187H69.8747L72.2107 9.6897H72.1537Z",
    fill: "#093635"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.267 14.0911C72.267 16.7611 74.023 18.6251 76.538 18.6251C78.668 18.6251 80.169 17.2221 80.364 15.0511L80.368 15.0041H78.452L78.448 15.0421C78.293 16.2491 77.598 16.9421 76.538 16.9421C74.847 16.9421 74.245 15.4691 74.245 14.0911C74.245 13.4051 74.41 11.1681 76.538 11.1681C77.467 11.1681 78.257 11.8031 78.375 12.6441L78.38 12.6811H80.296L80.291 12.6331C80.073 10.7201 78.598 9.4851 76.538 9.4851C73.983 9.4851 72.267 11.3351 72.267 14.0911Z",
    fill: "#093635"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9018 12.1419C88.9018 13.8109 90.2428 14.3069 91.4998 14.6409L92.0528 14.7819C93.1088 15.0419 94.0208 15.2659 94.0208 16.0279C94.0208 16.9889 92.7718 17.0629 92.3898 17.0629C91.8318 17.0629 90.5298 16.9119 90.5298 15.5069V15.4649H88.6128V15.5069C88.6028 16.3489 88.8678 17.0479 89.3988 17.5859C90.0618 18.2559 91.0978 18.6249 92.3168 18.6249C94.5508 18.6249 95.9378 17.5469 95.9378 15.8099C95.9378 13.8889 94.1138 13.4389 93.4268 13.2689L93.3518 13.2499L93.1608 13.2019C91.1758 12.6889 90.8188 12.5969 90.8188 11.9849C90.8188 11.2929 91.4968 11.0469 92.0758 11.0469C93.1558 11.0469 93.6818 11.4509 93.7318 12.3139L93.7348 12.3549H95.6488V12.3119C95.6488 10.5409 94.3448 9.4839 92.1608 9.4839C90.5418 9.4839 88.9018 10.3969 88.9018 12.1419Z",
    fill: "#093635"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.206 9.6897H96.1163V11.3747H98.6943V18.4187H100.672V11.3747H103.249V9.6897H103.206Z",
    fill: "#093635"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.097 9.6897H104.163V18.4187H110.332V16.7367H106.14V9.6897H106.097Z",
    fill: "#093635"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 9,
    width: 7,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.233 9.6897H117.849V18.4187H111.233V9.6897Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.709 9.6897H111.233V18.4187H117.849V16.7367H113.211V14.7037H117.379V13.1397H113.211V11.3747H117.752V9.6897H117.709Z",
    fill: "#093635"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0238 25.6487H46.6498V23.1437H48.0238C48.7948 23.1437 49.5848 23.2937 49.5848 24.3967C49.5848 25.4997 48.7948 25.6487 48.0238 25.6487ZM48.5238 21.5817H44.7818H44.7388V30.3107H46.6498V27.2117H48.5238C50.6718 27.2117 51.4368 25.7577 51.4368 24.3967C51.4368 23.0357 50.6718 21.5817 48.5238 21.5817Z",
    fill: "#093635"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5766 21.5813H52.3276V30.3103H58.7126V28.6263H54.2386V26.5943H58.2596V25.0313H54.2386V23.2663H58.6196V21.5813H58.5766Z",
    fill: "#093635"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7474 25.4915H61.7914V23.1445H63.7474C64.5634 23.1445 64.9604 23.5225 64.9604 24.2995C64.9604 25.1125 64.5744 25.4915 63.7474 25.4915ZM67.1074 30.2435C66.8404 29.8455 66.8064 29.0735 66.7804 28.5095L66.7664 28.2185C66.6894 27.0705 66.2984 26.4095 65.5814 26.1855C66.4334 25.8025 66.8704 25.0745 66.8704 24.0095C66.8704 22.6025 65.8314 21.5815 64.3984 21.5815H59.9254H59.8824V30.3105H61.7914V26.9335H63.5734C64.4314 26.9335 64.7814 27.2655 64.9134 28.2035L64.9794 28.9015C65.0174 29.3965 65.0564 29.9095 65.2074 30.2845L65.2184 30.3105H67.1524L67.1074 30.2435Z",
    fill: "#093635"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2522 21.5813H74.6512C74.6512 21.5813 72.8902 27.2833 72.8352 27.4623C72.7762 27.2843 70.9152 21.5813 70.9152 21.5813H68.2722V30.3103H70.0652V24.3963C70.1802 24.7353 72.0492 30.3103 72.0492 30.3103H73.5182C73.5182 30.3103 75.3872 24.6823 75.5012 24.3383V30.3103H77.2952V21.5813H77.2522Z",
    fill: "#093635"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.0081 26.8841C81.0441 26.7771 81.9851 24.0171 82.0401 23.8561C82.0931 24.0181 83.0031 26.7781 83.0381 26.8841H81.0081ZM83.0241 21.5811H82.9931H81.0921L77.9111 30.3111H79.8511C79.8511 30.3111 80.4831 28.4431 80.5021 28.3861H83.5431C83.5621 28.4441 84.1711 30.3111 84.1711 30.3111H86.1581L83.0241 21.5811Z",
    fill: "#093635"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3001 15.0403C83.3361 14.9333 84.2781 12.1733 84.3321 12.0123C84.3851 12.1733 85.2951 14.9353 85.3301 15.0403H83.3001ZM85.3171 9.7383H85.2851H83.3841L80.2031 18.4673H82.1431C82.1431 18.4673 82.7761 16.5993 82.7941 16.5423H85.8351C85.8541 16.6013 86.4631 18.4673 86.4631 18.4673H88.4501L85.3171 9.7383Z",
    fill: "#093635"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.8246 21.5813H92.0736V27.3073C91.9636 27.1223 88.6546 21.5813 88.6546 21.5813H86.7736V30.3103H88.5676V24.5993C88.6786 24.7813 91.9756 30.3103 91.9756 30.3103H93.8676V21.5813H93.8246Z",
    fill: "#093635"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.635 21.5813H95.3851V30.3103H101.77V28.6263H97.2961V26.5943H101.317V25.0313H97.2961V23.2663H101.677V21.5813H101.635Z",
    fill: "#093635"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.979 21.5813H108.227V27.3073C108.118 27.1223 104.809 21.5813 104.809 21.5813H102.928V30.3103H104.722V24.5993C104.833 24.7823 108.13 30.3103 108.13 30.3103H110.022V21.5813H109.979Z",
    fill: "#093635"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.731 21.5813H110.889V23.2663H113.376V30.3103H115.287V23.2663H117.774V21.5813H117.731Z",
    fill: "#093635"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpbsLogo);
export default __webpack_public_path__ + "static/media/npbs-logo.af50b9654127f7627180cdf672a22334.svg";
export { ForwardRef as ReactComponent };